import React, { Component } from 'react'
import PDFviewer from 'Tyan/components/PDFviewer'
import Message from 'Tyan/components/Message'
import { Image } from '@sencha/ext-modern'
import { getUrl } from 'Tyan/public'

export default class ShowFile extends Component {
	render() {
		const { match: { params: { path: _path, ext: _ext } } } = this.props
		const path = decodeURIComponent(_path)
		const ext = decodeURIComponent(_ext)
		return ext === 'pdf' && <PDFviewer url={getUrl(path)} /> ||
			['png', 'jpg'].indexOf(ext) > -1 && <Image mode="" src={getUrl(path)} width="100%" height="auto" scrollable /> ||
			<Message text="无法显示该类型文件" subtext={ext} />
	}
}